import React from 'react';
import { FormControl } from '@mui/material';
import { useTheme } from '@mui/material/styles';

export const CustomFormControl = ({ children, sx, colorTheme = 'light' }) => {
  const theme = useTheme();
  const defaultStyles = {
    marginTop: '8px',
    marginBottom: '6px',
    ...sx,
  };

  if (colorTheme === 'dark') {
    const darkPalette = theme.palette.darkMode;

    return (
      <FormControl
        fullWidth
        sx={{
          '& .MuiInputBase-root .MuiOutlinedInput-notchedOutline': {
            borderColor: darkPalette.xxlightGrey,
          },
          '& .MuiInputLabel-root': {
            color: darkPalette.contrastText,
            borderColor: darkPalette.xxlightGrey,

            '&.Mui-focused': {
              color: darkPalette.contrastText,
            },
          },
          '& .MuiInputBase-input': {
            color: darkPalette.contrastText,
          },
          ...defaultStyles,
        }}
      >
        {children}
      </FormControl>
    );
  }

  return (
    <FormControl
      fullWidth
      sx={{
        '& .MuiInputBase-root.Mui-focused .MuiOutlinedInput-notchedOutline': {
          borderColor: theme.palette.secondaryLight.dark,
        },
        '& .MuiInputLabel-root.Mui-focused': {
          color: theme.palette.secondaryLight.dark,
        },
        color: theme.palette.secondary.dark,
        ...defaultStyles,
      }}
    >
      {children}
    </FormControl>
  );
};
